import { useState, useRef } from 'react';
import { bool, func, node, object, string } from 'prop-types';
import classNames from 'classnames';

import IconPlus from '../IconPlus/IconPlus';
import FilterForm from '../FilterForm/FilterForm';

import css from './FilterPlain.module.css';

const FilterPlainComponent = props => {
  const [isOpen, setIsOpen] = useState(true);
  const filterContent = useRef(null);

  const handleChange = values => {
    props.onSubmit(values);
  };

  const handleClear = () => {
    const { onSubmit, onClear } = props;
    if (onClear) {
      onClear();
    }
    onSubmit(null);
  };

  const toggleIsOpen = () => {
    setIsOpen(prev => !prev);
  };

  const {
    rootClassName = null,
    className = null,
    plainClassName = null,
    id,
    label,
    labelSelection = null,
    labelSelectionSeparator = null,
    isSelected,
    children,
    initialValues = null,
    keepDirtyOnReinitialize = false,
    contentPlacementOffset,
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.filterHeader}>
        <button className={css.labelButton} onClick={toggleIsOpen}>
          <span className={css.labelButtonContent}>
            <span className={css.labelWrapper}>
              <span className={css.label}>
                {label}
                {labelSelection && labelSelectionSeparator ? labelSelectionSeparator : null}
                {labelSelection ? (
                  <span className={css.labelSelected}>{labelSelection}</span>
                ) : null}
              </span>
            </span>
            <span className={css.openSign}>
              <IconPlus isOpen={isOpen} isSelected={isSelected} />
            </span>
          </span>
        </button>
      </div>
      <div
        id={id}
        className={classNames(plainClassName, css.plain, { [css.isOpen]: isOpen })}
        ref={filterContent}
      >
        <FilterForm
          id={`${id}.form`}
          liveEdit
          contentPlacementOffset={contentPlacementOffset}
          onChange={handleChange}
          initialValues={initialValues}
          keepDirtyOnReinitialize={keepDirtyOnReinitialize}
        >
          {children}
        </FilterForm>
        <button className={css.clearButton} onClick={handleClear}>
          Clear
        </button>
      </div>
    </div>
  );
};



FilterPlainComponent.propTypes = {
  rootClassName: string,
  className: string,
  plainClassName: string,
  id: string.isRequired,
  onSubmit: func.isRequired,
  label: node.isRequired,
  labelSelection: node,
  labelSelectionSeparator: node,
  isSelected: bool.isRequired,
  children: node.isRequired,
  initialValues: object,
  keepDirtyOnReinitialize: bool,
};

export default FilterPlainComponent;
